const DocumentsActionTypes = {
  ADD_DOCUMENTS_TO_LIST: 'ADD_DOCUMENTS_TO_LIST',
  MODIFY_PAGINATION: 'MODIFY_PAGINATION',
  MODIFY_SORTING: 'MODIFY_SORTING',
  MODIFY_FILTERS: 'MODIFY_FILTERS',
};

export default DocumentsActionTypes;
